import vehicleModule from "./vehicleModule"
import vehicleView from "./vehicleView.html"

vehicleModule.config(["editionServiceProvider", (editionServiceProvider) => {
    editionServiceProvider.registerEdition("vehicle", vehicleView, "vehicleController")
}])